<template>
  <div class="user">
    <h1>{{ msg }}</h1>
    <div v-if="showHistoriesDialog" id="historieslist">
    <h3>历史记录：</h3>
    <table>
 <thead>
 <tr>
 <th>id</th>
 <th>名称</th>
 <th>动作</th>
 <th>时间</th>
     </tr>
 </thead>
 <tbody>
 <tr v-for="(item, index) in histories" :key = "item.id">
 <td>{{ item.bookId }}</td>
 <td>{{ item.book.name }}</td>
 <td>{{ item.why | whyStr }}</td>
 <td>{{ item.created_at }}</td>
  </tr>
 </tbody>
 </table><br/>
    <button @click="showHistoriesDialog = false">关闭</button>
    </div>
    <div v-else="showHistoriesDialog" id="userlist">
    <div>
 <form accept-charset="UTF-8">
  <label for="words">搜索词</label><input type="text" v-model="words" id="words" /><br/>
 <button @click="searchNow">搜索</button>
 <button @click="searchClean">清空</button>
  </form>
 </div>
 <div>
 目前匹配到用户： {{ total }} 个。
 </div>
 <div id="user">
 <table>
 <thead>
 <tr>
 <th>UID</th>
 <th>昵称</th>
 <th>角色</th>
 <th>手机</th>
 <th>邮件</th>
 <th>性别</th>
 <th>生日</th>
 <th>注册日期</th>
 <th>最后登录</th>
   <th> 操作 </th>
 </tr>
 </thead>
 <tbody>
 <tr v-for="(item, index) in users" :key = "item.uid">
 <td><h5>{{ item.uid }}</h5></td>
 <td><input type="text" v-model="item.nickname"></td>
 <td><input type="text" :value="item.role | roleStr" readonly="readonly"></td>
  <td><input type="text" v-model="item.phone" readonly="readonly"></td>
  <td><input type="text" v-model="item.email" readonly="readonly"></td>
 <td>
 <select v-model="item.gender">
 <option value="0">保密</option>
 <option value="1">男</option>
 <option value="2">女</option>
 </select>
  </td>
  <td><input type="text" v-model="item.birthday"></td>
  <td><input type="text" v-model="item.created_at"  readonly="readonly"></td>
  <td><input type="text" v-model="item.updated_at"  readonly="readonly"></td>
  <td>
  <button @click="userHistory(index)">浏览记录</button>
  <button @click="userUpload(index)">上传记录</button>
 <button @click="userEdit(index)">修改资料</button>
 <button @click="userDelete(index)">封号处理</button>
 </td>
 </tr>
 </tbody>
 </table>
</div>

 <a v-if="moreBtn" href="javascript:void(0);" v-on:click="loadMore">加载更多</a>
 <span v-else="moreBtn">全部加载完毕</span>
 </div>
 </div>
</template>

<script>
import axios from "axios"
export default {
  name: 'User',
  data () {
    return {
      msg: '用户管理',
      total: 0,
 moreBtn: false,
 isLogin: false,
 words: '',
      lastId: 0,
 users: [],
 showHistoriesDialog: false,
 histories: [],
    }
  },
    mounted() {
 if (sessionStorage.getItem("account") && sessionStorage.getItem("token")) {
 this.isLogin = true;
 this.uid = sessionStorage.getItem("uid")
 this.token = sessionStorage.getItem("token")
 this.nickname = sessionStorage.getItem("nickname")
 try {
 this.amount = parseInt(sessionStorage.getItem("amount"));
 } catch (e) {}
 this.typ = sessionStorage.getItem("typ");
 // 最后去抓取数据
 this.loadUsersData()
 }
 }, // mounted
  methods: {
  loadUsersData() {
  						const query = {
 uid: this.uid,
 access_token: this.token,
 lastId: this.lastId,
 search: this.words,
   time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
 query.search = encodeURIComponent(query.search)
  const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}admin/users?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
  if (response.data.code == 0) {
 this.total = response.data.data.total
 for (const it of response.data.data.items) {
 this.users.push(it);
 this.lastId = it.uid;
 } // for
 this.moreBtn = this.users.length <this.total
 } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })
 }, // loadUsersData
  searchNow() {
  
  }, // searchNow
  searchClean() {
  
  }, // searchClean
  userUpload(index) {
  const user = this.users[index]
  if(!user) {
  return;
  }
  this.$router.push({
  path: '/book',
  query: {
  uploaderUid: user.uid,
  },
  })
  }, // userUpload
  userHistory(index) {
  const user = this.users[index]
  if(!user) {
  return;
  }
  const query = {
 uid: this.uid,
 access_token: this.token,
 who: user.uid,
    time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
   const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}admin/user/histories?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
  if (response.data.code == 0) {
  this.histories = response.data.histories;
  this.showHistoriesDialog = true
  } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })
    }, // userHistory
  userEdit(index) {
  
  }, // userEdit
  userDelete(index) {
  
  }, // userDelete
  },  // methods
  filters: {
      roleStr(role) {
  switch(role) {
  case 100:
  return '管理'
  default:
    return '普通'
  } // switch
  }, // roleStr
  whyStr(why) {
  switch(why) {
  case 1:
  return '浏览'
  case 2:
  return '阅读'
  default:
    return '未知'
  } // switch
  }, // whyStr

},  // filters
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue